<div [ngClass]="['tag', status]">
    <span class="ellipsis tag-label">{{ label }}</span>
    <button *ngIf="removable" type="button" (click)="onRemove()" aria-label="Remove tag">
        <nb-icon icon="close-outline" status="basic"></nb-icon>
    </button>
</div>
